import type { ReactNode } from "react";

/** Compact optional controls without burying the work/result underneath them. */
export function Disclosure({ title, open, children }: { title: string; open?: boolean; children: ReactNode }) {
  return <details className="v365-disclosure" open={open}><summary>{title}</summary><div>{children}</div></details>;
}
